/**
 * Vote state
 *
 * @export
 * @class VoteState
 */
var VoteState = /** @class */ (function () {
    function VoteState() {
        /**
         * The list of posts vote
         *
         * @type {({[postId: string]: {[voteId: string]: Vote}} | null)}
         * @memberof VoteState
         */
        this.postVotes = null;
        /**
         * If posts vote are loaded {true} or not {false}
         *
         * @type {Boolean}
         * @memberof VoteState
         */
        this.loaded = false;
    }
    return VoteState;
}());
export { VoteState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/votes/VoteState.ts
// module id = 576
// module chunks = 50